import { logger } from "c7-logger/index";

import {
  getIsFeatureEnabled,
  getIsFeatureFlagServiceReady,
} from "splitio-loader/src/utils/get-split-io-flag";

export const loadDeviceFingerprintSDK = (
  target: string = "",
  deviceFingerprintSDK: string
) => {
  return new Promise<void>((resolve, reject) => {
    getIsFeatureFlagServiceReady()
      ?.then(() => {
        const isShieldDeviceFingerprintEnabled = getIsFeatureEnabled(
          target,
          "msthps-2459-shield"
        );

        if (
          isShieldDeviceFingerprintEnabled &&
          deviceFingerprintSDK &&
          !document.querySelector(`script#deviceFingerprintSDK`)
        ) {
          const script = document.createElement("script");
          script.id = "deviceFingerprintSDK";
          script.setAttribute("src", deviceFingerprintSDK);
          script.async = true;
          script.onload = () => resolve();
          script.onerror = () => {
            reject(new Error("Error loading DFP SDK"));
          };
          document.body.appendChild(script);
        }
      })
      .catch(() => {
        logger.error("Error loading feature flag service");
      });
  });
};
